"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const uicon_check_shield_style_1 = __importDefault(require("./uicon.check.shield.style"));
class UiconCheckShield extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, size } = this.props;
            return (jsx_runtime_1.jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", viewBox: "0 0 32 32", "aria-hidden": "true", className: classes.root, style: { width: size, height: size } }, { children: jsx_runtime_1.jsx("path", { fillRule: "nonzero", d: "M15.993 31.998c-.255.002-.507-.055-.736-.167C6.28 27.363 1.381 18.039 2.117 6.286v-.319c0-.442.175-.866.486-1.18.304-.317.725-.498 1.165-.499 3.927 0 4.163-2.22 4.163-2.665C7.953.731 8.689.007 9.582 0h12.877c.903.007 1.644.748 1.651 1.651 0 .43.25 2.637 4.163 2.637.45.004.881.189 1.193.513.308.308.474.731.458 1.166v.319c.708 11.808-4.093 21.147-13.168 25.601-.239.097-.498.135-.763.111zm6.369-30.194H9.693c-.102 1.715-1.435 4.228-5.828 4.288V6.3C3.227 17.387 7.667 26.087 16.09 30.208c8.325-4.163 12.696-12.821 12.044-23.881V6.05c-4.335 0-5.656-2.585-5.772-4.246zM13.651 21.47c-.208-.001-.407-.083-.555-.229l-4.469-4.482 1.108-1.096 3.916 3.951 8.602-8.795 1.12 1.097-9.156 9.361c-.15.144-.347.23-.554.241l-.012-.048z" }, void 0) }), void 0));
        };
    }
}
UiconCheckShield.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    size: prop_types_1.default.number
};
UiconCheckShield.defaultProps = {
    size: null
};
exports.default = react_jss_1.default(uicon_check_shield_style_1.default)(UiconCheckShield);
//# sourceMappingURL=uicon.check.shield.js.map